function getState(checked) {
  return checked ? "checked" : "unchecked";
}
export { getState };
//# sourceMappingURL=utils.mjs.map
